import script from "./DetailsLocations.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsLocations.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__